import { activeTab, realtimeInterval } from '../state';
import { fetchRealtimeData } from './fetchRealtimeData';

/**
 * Tab değiştirme fonksiyonu
 * @param {string} tab - Değiştirilecek tab (historical veya realtime)
 * @param {boolean} isConnected - Google bağlantı durumu
 * @param {string} assetId - Asset ID
 */
export function switchTab(tab, isConnected, assetId) {
  activeTab.value = tab;

  // Realtime tab'ına geçildiğinde veri getir
  if (tab === "realtime" && isConnected) {
    fetchRealtimeData(assetId);

    // Periyodik yenileme başlat (her 30 saniyede bir)
    if (realtimeInterval.value) clearInterval(realtimeInterval.value);
    realtimeInterval.value = setInterval(() => fetchRealtimeData(assetId), 30000);
  } else {
    // Interval'ı temizle
    if (realtimeInterval.value) {
      clearInterval(realtimeInterval.value);
      realtimeInterval.value = null;
    }
  }
}